<template>
  <a-menu
    :inline-collapsed="collapsed"
    mode="inline"
    theme="dark"
    :open-keys="openKeys"
    :selectedKeys="selectedKeys"
    @click="handleMenuClick"
    @openChange="handleOpenChange"
  >
    <template v-for="item in menus">
      <a-menu-item v-if="!item.children" :key="item.id">
        <a-icon :type="item.icon" />
        <span>{{ item.name }}</span>
      </a-menu-item>
      <sub-menu v-else :key="item.id" :menu-info="item" />
    </template>
  </a-menu>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SubMenu from '@/layout/SubMenu'
import { SET_MENU_URL } from 'config/mutation-types/user'

export default {
  name: 'SideMenu',
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this._initMenu(newValue)
      },
    },
    collapsed(val) {
      if (val) {
        this.openKeys = []
      } else {
        this._initMenu(this.$route)
      }
    },
  },
  data() {
    return {
      // 初始化选中的menu
      openKeys: [],
      selectedKeys: [],
    }
  },
  computed: {
    ...mapGetters('user', ['menus', 'flatMenus']),
    ...mapGetters('app', ['collapsed']),
  },
  components: { SubMenu },
  methods: {
    ...mapMutations('user', [SET_MENU_URL]),
    handleMenuClick({ key }) {
      const info = this.flatMenus.filter(item => item.id === key)[0]
      this.$router.push(info.url)
    },
    // 只展开一项
    handleOpenChange(openKeys) {
      if (openKeys.length) {
        if (
          this.openKeys.length === 2 &&
          openKeys.length === 1 &&
          this.openKeys[1] === openKeys[0]
        ) {
          this.openKeys = []
        } else {
          this.openKeys = this._recursivePid(openKeys[openKeys.length - 1])
        }
      } else {
        this.openKeys = []
      }
    },
    _recursivePid(id) {
      let arr = []

      if (id.length > 1) {
        arr.unshift(id)

        const { pid } = this.flatMenus.find(item => item.id === id)
        arr = [...this._recursivePid(pid), ...arr]
      }

      return arr
    },
    _initMenu(route) {
      const routeName = route.path.split('/').filter(Boolean)
      this.selectedKeys = []

      // 初始化选中的菜单
      const info = this.flatMenus.filter(
        item => item.index === routeName[routeName.length - 1],
      )[0]
      if (info) {
        const { pid, id } = info
        const menuIndex = info.url.split('/').filter(Boolean)
        this.selectedKeys.push(id)

        this.openKeys = this._recursivePid(pid)

        this[SET_MENU_URL](menuIndex)
      }
    },
  },
}
</script>
